import createImage from "../../utils/create-image";
import vertexShader from "./shaders/detectVert.glsl";
import fragmentShader from "./shaders/detectFrag.glsl";

const SideColors = ['#000', '#fff'];

class CubemapSeamDetector {
    constructor() {
        this._images = SideColors.map(color => createImage(color));
        this._imageLoadPromise = Promise.all(this._images.map(image => image.isReadyPromise));
    }

    waitImageLoad() {
        return this._imageLoadPromise;
    }

    initRender() {
        const [img0, img1] = this._images;
        this._texture = new THREE.CubeTexture([img0, img0, img0, img0, img1, img1]);
        this._texture.needsUpdate = true;

        this._geometry = new THREE.PlaneGeometry(2, 2);
        this._material = new THREE.RawShaderMaterial({ uniforms: { cubeTexture: { value: this._texture } }, vertexShader, fragmentShader });
        this._object = new THREE.Mesh(this._geometry, this._material);
        this._scene = new THREE.Scene();
        this._camera = new THREE.OrthographicCamera(-1, 1, 1, -1, -1, 1);
        this._scene.add(this._object);
        this._scene.add(this._camera);

        this._renderTarget = new THREE.WebGLRenderTarget(1, 1);
    }

    renderAndCheckSeamless(renderer) {
        const buffer = new Uint8Array(4);

        renderer.render(this._scene, this._camera, this._renderTarget, true);
        renderer.readRenderTargetPixels(this._renderTarget, 0, 0, 1, 1, buffer);

        const r = buffer[0];
        return r >= 64 && r < 192;
    }
}

export default CubemapSeamDetector;
